import type { I18nLang, IBaseDiseaseInfo, IBaseSourceLangName, ILang } from '@patsnap/synapse_common_interface'
import { getLangDegraded } from '@patsnap/synapse_common_utils'
import { getSortFnByLang } from './common'

export function getDiseaseSynonyms<T extends { alias?: IBaseSourceLangName[] }>(data: T, lang: ILang) {
  return (
    data.alias
      ?.filter((item) => !!item.name)
      .map((item) => item.name)
      .sort(getSortFnByLang(lang)) || []
  )
}

/**
 * 获取药物名称
 * @param data
 * @param locale
 * @param isDegraded 是否降级查找
 * @returns
 */
export function getDiseaseName<T extends IBaseDiseaseInfo>(data: T, locale: I18nLang) {
  return getLangDegraded(data, locale)
}
